try {
  class CustomBogoOffer {
    constructor() {
      this.giftDataElement = document.getElementById('bogo-gift-data');
      if (this.giftDataElement) {
        this.initProductPage();
      }
      if (window.location.pathname.includes('/cart')) {
        this.initCartPage();
      }
    }

    initProductPage() {
      // This function remains unchanged.
      this.productForm = document.querySelector('product-form.m-product-form--main');
      this.atcButton = this.productForm ? this.productForm.querySelector('button[name="add"]') : null;
      if (!this.atcButton) { return; }
      this.overlay = document.getElementById('bogo-popup-overlay');
      this.modal = document.getElementById('bogo-popup-modal');
      this.closeButton = document.getElementById('bogo-popup-close');
      this.skipButton = document.getElementById('bogo-popup-skip');
      this.grid = document.getElementById('bogo-popup-grid');
      this.atcButton.addEventListener('click', this.handleAtcClick.bind(this), { capture: true });
      this.closeButton.addEventListener('click', () => this.closePopup());
      this.overlay.addEventListener('click', () => this.closePopup());
      this.skipButton.addEventListener('click', () => this.addItemsToCart(null));
    }

    initCartPage() {
      // This function remains unchanged.
      setTimeout(() => this.validateCart(), 500);
      this.initializeMasterListener();
    }

    initializeMasterListener() {
      // This function remains unchanged.
      console.log('BOGO SCRIPT: Initializing master click listener.');
      document.body.addEventListener('click', (event) => {
        const removeButton = event.target.closest('m-cart-remove-button');
        if (removeButton) {
          console.log('BOGO SCRIPT: Remove button click detected!');
          this.handleRemoveAction(removeButton);
        }
      });
    }

    // ========================================================================
    // THIS IS THE CORRECTED FUNCTION FOR INSTANT REMOVAL
    // ========================================================================
    async handleRemoveAction(clickedButton) {
      console.log('BOGO SCRIPT: Handling remove action.');

      // --- [START] NEW "INSTANT HIDE" LOGIC ---
      // Find the specific cart item row that the clicked button belongs to.
      // Based on your theme's structure, `m-cart-item` is the most likely candidate for the row.
      const rowOfItemBeingRemoved = clickedButton.closest('.m-cart-item');

      // Check if the item being removed is a QUALIFYING item (i.e., it is NOT a gift).
      if (rowOfItemBeingRemoved && !rowOfItemBeingRemoved.querySelector('[data-property-key="_is_bogo_gift"]')) {
        console.log('BOGO SCRIPT: A qualifying item is being removed.');
        
        // Find the main cart container.
        const cartContainer = document.getElementById('MinimogCart');
        if (cartContainer) {
          // Find the gift item's row WITHIN the cart container.
          const giftRow = cartContainer.querySelector('.m-cart-item:has([data-property-key="_is_bogo_gift"])');
          
          if (giftRow) {
            console.log('BOGO SCRIPT: Found gift row. Hiding it immediately.');
            // Hide the gift row instantly.
            giftRow.style.display = 'none';
          } else {
            console.log('BOGO SCRIPT: Could not find the gift row to hide.');
          }
        }
      } else {
        console.log('BOGO SCRIPT: A gift item is being removed. No need to hide anything else.');
      }
      // --- [END] NEW "INSTANT HIDE" LOGIC ---

      // The rest of this function performs the actual removal in the background.
      // This logic is already working correctly and remains unchanged.
      try {
        const initialCart = await (await fetch('/cart.js')).json();
        const initialItemCount = initialCart.item_count;
        if (initialItemCount === 0) return;

        let attempts = 0;
        const maxAttempts = 20;

        const poll = setInterval(async () => {
          attempts++;
          const currentCart = await (await fetch('/cart.js')).json();
          const currentItemCount = currentCart.item_count;

          if (currentItemCount < initialItemCount) {
            clearInterval(poll);
            this.validateCart();
          } else if (attempts >= maxAttempts) {
            clearInterval(poll);
            this.validateCart();
          }
        }, 250);
      } catch (error) {
        console.error('BOGO SCRIPT: Error during remove action handler.', error);
      }
    }

    async validateCart() {
      // This function remains unchanged.
      console.log('BOGO SCRIPT: Running cart validation...');
      const response = await fetch('/cart.js');
      const cart = await response.json();
      let qualifyingItemsCount = 0;
      const giftItems = [];
      for (const item of cart.items) {
        if (item.properties && item.properties._is_bogo_gift === 'true') {
          giftItems.push(item.key);
        } else {
          qualifyingItemsCount += item.quantity;
        }
      }
      const giftItemsCount = giftItems.length;
      const updates = {};
      let cartNeedsUpdate = false;
      if (giftItemsCount > 0 && qualifyingItemsCount === 0) {
        giftItems.forEach(key => updates[key] = 0);
        cartNeedsUpdate = true;
      } else if (giftItemsCount > qualifyingItemsCount) {
        const excessCount = giftItemsCount - qualifyingItemsCount;
        for (let i = 0; i < excessCount; i++) {
          updates[giftItems[i]] = 0;
        }
        cartNeedsUpdate = true;
      }
      if (cartNeedsUpdate) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        window.location.href = '/cart';
      }
    }

    // --- All functions below this line are unchanged ---
    handleAtcClick(event) { event.preventDefault(); event.stopPropagation(); try { const gifts = JSON.parse(this.giftDataElement.textContent); if (gifts && gifts.length > 0) { this.populatePopup(gifts); this.openPopup(); } else { this.addItemsToCart(null); } } catch (e) { this.addItemsToCart(null); } }
    populatePopup(gifts) { this.grid.innerHTML = ''; gifts.forEach(gift => { const item = document.createElement('div'); item.className = 'bogo-popup-item'; item.innerHTML = ` <img src="${gift.image_url}" alt="${gift.title}"> <div class="bogo-popup-item-title">${gift.title}</div> <button type="button" class="bogo-popup-add-gift" data-variant-id="${gift.id}">Add Gift</button> `; this.grid.appendChild(item); }); this.grid.querySelectorAll('.bogo-popup-add-gift').forEach(button => { button.addEventListener('click', (e) => { const giftVariantId = e.target.dataset.variantId; this.addItemsToCart(giftVariantId); }); }); }
    addItemsToCart(giftVariantId) { this.atcButton.classList.add('m-spinner--active'); const originalVariantId = this.productForm.querySelector('input[name="id"]').value; const quantity = this.productForm.querySelector('input[name="quantity"]')?.value || 1; const items = [{ id: originalVariantId, quantity: quantity }]; if (giftVariantId) { items.push({ id: giftVariantId, quantity: 1, properties: { '_is_bogo_gift': 'true' } }); } fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(() => { window.location.href = '/cart'; }).catch(error => { console.error('BOGO SCRIPT: Error adding items to cart.', error); this.atcButton.classList.remove('m-spinner--active'); }); }
    openPopup() { this.overlay.classList.add('visible'); this.modal.classList.add('visible'); }
    closePopup() { this.atcButton.classList.remove('m-spinner--active'); this.overlay.classList.remove('visible'); this.modal.classList.remove('visible'); }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CustomBogoOffer();
  });

} catch (e) {
  console.error('BOGO SCRIPT: FATAL SYNTAX ERROR.', e);
}
